/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';

import './animation026.less';

interface IAnimation026SubItem {
  img: string;
  title: string;
  content: string;
}

interface IAnimation026Item {
  text: string;
  subtitle?: string;
  subItems?: IAnimation026SubItem[];
  color: string;
}

interface IAnimation026Props {
  items: IAnimation026Item[];
  className?: string;
  onCompleted?: () => void;
}

const Animation026: React.FunctionComponent<IAnimation026Props> = ({
  items,
  className,
  onCompleted,
}) => {
  const [play, setPlay] = React.useState(1);
  const [isPlayed, setIsPlayed] = React.useState(false);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [currPage, setCurrPage] = React.useState(0);
  const [modalItem, setModalItem] = React.useState<IAnimation026SubItem[]>();
  const [show, setShow] = React.useState(true);
  const [show1, setShow1] = React.useState<number[]>([]);
  const [show2, setShow2] = React.useState<number[]>([]);
  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const startPlay = (next = 1) => {
    if (isPlayed) {
      return;
    }
    next += 1;
    setPlay(next);
    setIsPlayed(true);
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1000);
    } else {
      console.log('Animation021 onCompleted');
      onCompleted && onCompleted();
    }
  };

  return (
    <div className={`animation026 component ${className || ''}`}>
      {items.map((itm: IAnimation026Item, idx: number) => (
        <>
          <div
            key={idx}
            className={`animation026-item animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            onClick={() => startPlay()}
          >
            <img
              className={`click-point ${play > 1 ? 'hide' : ''}`}
              src={ImgPoint}
              alt=""
            />
            <div
              className="animation026-rectangle-div"
              style={{ backgroundColor: itm.color }}
            >
              <div className="animation026-text">
                {itm.text}
                {itm.subtitle ? (
                  <div className="sub-task-text">
                    <Button
                      style={{ fontSize: '1.6rem' }}
                      type="link"
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalOpen(true);
                        setModalItem(itm.subItems);
                        setShow2([...show2, idx]);
                      }}
                    >
                      {itm.subtitle}
                      <img
                        className="click-point1"
                        hidden={show2.includes(idx)}
                        src={ImgPoint}
                        alt=""
                      />
                    </Button>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </>
      ))}
      {modalItem && (
        <Modal
          width="80%"
          className="animation026-modal-E-commerce"
          title={
            <div className="animation026-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: modalItem[currPage]?.content }}
            />
          )}
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow(false);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </div>
  );
};

export default Animation026;
